import { EventLogType, EventLogStatus as SchemaEventLogEnum } from "@clockwise/schema/v2";
import { Timeline, TimelineLogType } from "@clockwise/web-commons/src/ui/timeline/timeline";
import { shouldRenderEventAutopilotStatus as shouldRenderEventFlexStatus } from "@clockwise/web-commons/src/util/event-history.util";
import { findLastIndex, isEmpty } from "lodash";
import { DateTime } from "luxon";
import React from "react";
import { Header } from "./Header";
import { DefragInfoCard } from "./cards/DefragInfoCard";
import { EventFlexibilityStatusCard } from "./cards/EventFlexibilityStatusCard";
import { EventFlexibilityStatusIcon } from "./icons/EventFlexibilityStatus";
import { getTimelineIcon } from "./icons/getTimelineIcon";
import { EventLogEntries, EventLogStatus, Flexibility } from "./types";

export const HistoryOn = ({
  entries,
  flexibility,
  historyStatus,
  nextDefrag,
  onGoToBilling,
  onTimelineExpanded,
  onUnpauseEvent,
  onViewPlans,
  showJoinExistingPlan,
}: {
  entries: EventLogEntries;
  flexibility: Flexibility | null;
  historyStatus: EventLogStatus;
  nextDefrag: string | null;
  onGoToBilling: () => void;
  onTimelineExpanded: () => void;
  onUnpauseEvent: () => void;
  onViewPlans: () => void;
  showJoinExistingPlan: boolean;
}) => {
  const isMissingHistory = historyStatus === SchemaEventLogEnum.Incomplete;
  const shouldRenderDefragLog =
    flexibility?.isFlexible && shouldRenderEventFlexStatus(flexibility.status);

  const futureLogs = shouldRenderDefragLog
    ? [
        {
          id: "Flexibility Status",
          description: (
            <EventFlexibilityStatusCard
              flexibility={flexibility}
              nextDefrag={nextDefrag}
              onGoToBilling={onGoToBilling}
              onUnpauseEvent={onUnpauseEvent}
              onViewPlans={onViewPlans}
              showJoinExistingPlan={showJoinExistingPlan}
            />
          ),
          defragInfo: null,
          timestamp: null,
          type: TimelineLogType.FutureLog,
          icon: EventFlexibilityStatusIcon[flexibility.status],
        },
      ]
    : [];

  const lastConflictIndex = findLastIndex(
    entries,
    (entry) => entry.type === EventLogType.ClockwiseCouldNotResolveConflict,
  );
  const historicalLogs = entries.map((entry, index) => {
    const defragInfo = !isEmpty(entry.details) ? <DefragInfoCard details={entry.details} /> : null;
    const showWarning = index === lastConflictIndex;
    const Icon = getTimelineIcon(entry.type, showWarning);

    return {
      id: `${entry.type}-${entry.timestamp}`,
      description: entry.title,
      defragInfo,
      timestamp: DateTime.fromISO(entry.timestamp).toMillis(),
      type: TimelineLogType.PastLog,
      icon: Icon,
    };
  });

  const timelineLogs = [...historicalLogs, ...futureLogs];

  return (
    <>
      <Header />
      <div className="cw-pt-2">
        <Timeline
          timelineLogs={timelineLogs}
          isMissingHistory={isMissingHistory}
          trackTimelineExpanded={onTimelineExpanded}
        />
      </div>
    </>
  );
};
